import { Fragment, useEffect, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Laoding from "../../../../components/Loading";
import { getMethod, postMethod } from "../../../../function/helper";

function AuthModal({ close, nationalCode }) {
  const [loading, setLoading] = useState([true, false, false]);
  const [phone, setPhone] = useState("");
  const [smsSend, setSmsSend] = useState(false);
  const [code, setCode] = useState("");

  const getData = async () => {
    const url = "/user/v1/auth-sms?nationalCode=" + nationalCode;
    const response = await getMethod(url);
    setLoading(cur => {
      cur[0] = false;
      return [...cur];
    });

    if (response && response.status === 200) {
      setPhone(response.result);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const sendSMS = async () => {
    setLoading(cur => {
      cur[1] = true;
      return [...cur];
    });
    const response = await getMethod(
      "/user/v1/send-auth-sms?nationalCode=" + nationalCode
    );
    setLoading(cur => {
      cur[1] = false;
      return [...cur];
    });

    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
      }).then(res => {
        if (res.isConfirmed) {
          setSmsSend(true);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const sendCode = async () => {
    setLoading(cur => {
      cur[2] = true;
      return [...cur];
    });
    const response = await postMethod("/user/v1/auth-code", {
      nationalCode,
      code,
    });
    setLoading(cur => {
      cur[2] = false;
      return [...cur];
    });

    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
      }).then(res => {
        if (res.isConfirmed) {
          window.localStorage.clear();
          window.sessionStorage.clear();
          localStorage.setItem("token", response.data.data);
          window.location.href = "/";
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  return (
    <Modal show={true} centered={true} className="modal-nobg">
      <Modal.Header>
        <h5 className="my-0">ارسال پیامک احراز هویت</h5>
      </Modal.Header>
      <Modal.Body>
        {loading[0] === true && <Laoding />}
        {loading[0] === false && (
          <Fragment>
            <div>
              <p>
                <span>چهار رقم آخر شماره تلفن ثبت شده </span>
                <strong className="d-inline-flex ltr">{phone}</strong>
                <span> می‌باشد</span>
              </p>
              <p>
                در صورت تایید دکمه ی ارسال پیامک را بزنید و در غیر اینصورت با
                پشتیبانی تماس بگیرید
              </p>
            </div>

            {smsSend === true && (
              <div className="mt-4">
                <Form.Label>کد ارسال شده به تلفن خود را وارد کنید:</Form.Label>
                <Form.Control
                  type="number"
                  onChange={e => setCode(e.target.value)}
                />
              </div>
            )}
          </Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        {smsSend === false && (
          <Fragment>
            {loading[1] === true && (
              <button className="btn btn-primary">
                <div className="d-flex align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-1"> در حال ارسال</span>
                </div>
              </button>
            )}
            {loading[1] === false && (
              <button
                className="btn btn-primary"
                disabled={loading[0] === true}
                onClick={sendSMS}
              >
                ارسال پیامک
              </button>
            )}
          </Fragment>
        )}

        {smsSend === true && (
          <Fragment>
            {loading[2] === true && (
              <button className="btn btn-primary">
                <div className="d-flex align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-1"> در حال ارسال</span>
                </div>
              </button>
            )}
            {loading[2] === false && (
              <button className="btn btn-primary" onClick={sendCode}>
                ارسال کد وارد شده
              </button>
            )}
          </Fragment>
        )}

        <button className="btn btn-danger" onClick={close}>
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AuthModal;
